import React from 'react';
import { useRoutes } from 'react-router-dom';
import { DeviceAuthContext } from '../providers/DeviceAuthContextProvider';
export var DeviceConnectRouter = function (_a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    return useRoutes([
        {
            path: '/connect/:hash',
            element: React.createElement(ConnectRouteElement, { onSuccess: onSuccess, onFailure: onFailure }),
        },
    ]);
};
var ConnectRouteElement = function (_a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var ctx = React.useContext(DeviceAuthContext);
    if (!ctx) {
        throw new Error('<DeviceConnectRouter /> must be placed within <DeviceAuthContextProvider />');
    }
    React.useLayoutEffect(function () {
        if (ctx.isInitialized) {
            if (ctx.isAuthenticated && onSuccess) {
                onSuccess(ctx.device);
            }
            if (!ctx.isAuthenticated && onFailure) {
                onFailure();
            }
        }
    }, [ctx.isInitialized, ctx.isAuthenticated, ctx.device, onSuccess, onFailure]);
    return React.createElement(React.Fragment, null);
};
// ----------------------------------------------------------------------
